<div class="ui floating icon message margin-bottom-20">
    <div *ngIf="icon" class="ui image tiny">
        <img src="/assets/images/{{ icon }}.svg" />
    </div>
    <div class="content">
        <div class="header" *ngIf="title">{{ title }}</div>
        <p>
            <span *ngIf="subtitle" [innerHTML]="subtitle"></span>
            <a href="{{ link }}" target="_blank" *ngIf="link" class="learn-more">Learn More</a>
        </p>
        <ng-content></ng-content>
    </div>
</div>
